<template>
    <el-card shadow="never">
        <div class="header">
            <el-breadcrumb class="breadcrumb" separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">工作台</el-breadcrumb-item>
                <el-breadcrumb-item>套餐列表</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button type="primary" class="editbtn" @click="add">创建套餐</el-button>
        </div>
    </el-card>
    <el-card shadow="never" style="margin-top:20px">
        <el-table row-key="id" v-loading="baseData.loading" border :data="tableData.data" style="width: 100%;margin-top: 10px;">
          <el-table-column prop="id" label="ID" width="60"/>
          <el-table-column prop="title" label="标题"/>
          <el-table-column prop="type" label="充值类型" width="120">
            <template #default="scope">
              {{scope.row.type==1?'金额':'积分'}}
            </template>
          </el-table-column>
          <el-table-column prop="price" label="价格（元）" width="120"/>
          <el-table-column prop="count" label="年" width="60"/>
          <el-table-column prop="point" label="积分" width="60"/>
          <el-table-column prop="giftpoint" label="赠送积分" width="120"/>
          <el-table-column prop="cardnums" label="名片数量" width="100"/>
          <el-table-column prop="modeltype" label="充值模式" width="100"/>
          <el-table-column prop="remark" label="备注"/>
          <el-table-column prop="created_at" label="创建时间" width="180"/>
          <el-table-column label="状态" width="100">
            <template #default="scope">
                <el-switch
                  size="large"
                  @change="changeStatus(scope.row.id,scope.row.status)"
                  v-model="scope.row.status"
                  inline-prompt
                  active-text="正常"
                  inactive-text="暂停"
                  />
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="140" >
            <template #default="scope">
                <el-button size="small" @click="edit(scope.row)" type="primary">编辑</el-button>
                <el-popconfirm
                    confirm-button-text="Yes"
                    cancel-button-text="No"
                    title="你确定要删除?"
                    @confirm="del(scope.row.id)"
                >
                    <template #reference>
                        <el-button size="small" type="danger">删除</el-button>
                    </template>
                </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        
        <div class="pagestyle">
          <el-pagination
            v-model:current-page="searchForm.page"
            v-model:page-size="searchForm.limit"
            layout="sizes, prev, pager, next"
            :total="tableData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
    </el-card>

    <el-dialog v-model="baseData.addbox" :title="baseData.title">
      <el-form :model="form" label-width="120">
        <el-form-item label="名称">
          <el-input v-model="form.title" autocomplete="off" maxlength="150" show-word-limit/>
        </el-form-item>
        <el-form-item label="充值类型">
          <el-radio-group v-model="form.type">
            <el-radio :label="1">金额</el-radio>
            <el-radio :label="2">积分</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="价格">
          <el-input-number v-model="form.price" :precision="2" :step="0.1" :max="100000000" />
        </el-form-item>
        <el-form-item label="年份" v-if="form.type == 1">
          <el-input-number v-model="form.count" :precision="0" :step="1" :max="100000000" />
        </el-form-item>
        <el-form-item label="积分" v-if="form.type == 2">
          <el-input-number v-model="form.point" :precision="0" :step="1" :max="100000000" />
        </el-form-item>
        <el-form-item label="赠送积分">
          <el-input-number v-model="form.giftpoint" :precision="0" :step="1" :max="100000000" />
        </el-form-item>
        <el-form-item label="名片数量">
          <el-input-number v-model="form.cardnums" :precision="0" :step="1" :max="100000000" />
        </el-form-item>
        <el-form-item label="充值模式">
          <el-input-number v-model="form.modeltype" :precision="0" :step="1" :max="100000000" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" autocomplete="off" maxlength="150" show-word-limit/>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
              <el-radio :label="1">正常</el-radio>
              <el-radio :label="0">暂停</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="baseData.addbox = false">取消</el-button>
          <el-button type="primary" @click="save">
            提交
          </el-button>
        </span>
      </template>
    </el-dialog>
  </template>
  <script lang="ts" setup>
  import { reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  const searchForm = reactive({
    limit:10,
    page:1,
  })
  const baseData:any = reactive({
    companylist:[],
    loading:false,
    title:'',
    addbox:false,
  })
  const form:any = reactive({
    id:"",
    title:"",
    type:1,
    price:0.00,
    count:0,
    point:0,
    giftpoint:0,
    cardnums:0,
    modeltype:0,
    remark:"",
    status:1,
  })
  const tableData:any = reactive({
    data:[],
    total:0,
  })
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const getList = () => {
    baseData.loading = true
    api.setmealApi.list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        for(var i in res.data.list){
          res.data.list[i].status = res.data.list[i].status==1?true:false
          res.data.list[i].type = res.data.list[i].type ? parseInt(res.data.list[i].type) : 1
        }
        tableData.data = res.data.list
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const save = () => {
    baseData.loading = true
    if(form.id){
      api.setmealApi.edit(form).then((res:any)=>{
        baseData.loading = false
        if(res.code==200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          baseData.addbox = false
          getList()
        }else{
          ElMessage.error(res.message)
        }
      })
    }else{
      api.setmealApi.add(form).then((res:any)=>{
        baseData.loading = false
        if(res.code==200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          baseData.addbox = false
          getList()
        }else{
          ElMessage.error(res.message)
        }
      })
    }
  }
  const changeStatus = (id:number,status:number) => {
    baseData.loading = true
    if(status){
      status = 1
    }else{
      status = 0
    }
    api.setmealApi.changeStatus({id:id,status:status}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const add = () => {
    baseData.addbox = true
    baseData.title = '添加套餐'
    form.id = 0
    form.title = ""
    form.type = 1
    form.price = 0.00
    form.count = 0
    form.point = 0
    form.giftpoint = 0
    form.cardnums = 0
    form.modeltype = 0
    form.remark = ""
    form.status = 1
  }
  const edit = (data:any) => {
    baseData.addbox = true
    baseData.title = '编辑套餐'
    form.id = data.id
    form.title = data.title
    form.type = data.type
    form.price = data.price
    form.count = data.count
    form.point = data.point
    form.giftpoint = data.giftpoint
    form.cardnums = data.cardnums
    form.modeltype = data.modeltype
    form.remark = data.remark
    form.status = data.status == true ? 1 : 0
  }
  const del = (id:number) => {
    baseData.loading = true
    api.setmealApi.del({id:id}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  onMounted(() => {
    getList()
  })
  </script>